export default (that) => [
  {
    title: that.$l('table_label_orderImport_rowNum') || '行数',
    field: 'rowNum',
    width: 60,
    align: 'center',
    fixed: 'left',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_errorMsg') || '错误信息',
    field: 'errorMsg',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    fixed: 'left',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_hxPreOrderNo') || '备货订单号',
    field: 'hxPreOrderNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_hxPurchaseNo') || '采购单号',
    field: 'hxPurchaseNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_purchaseDate') || '采购日期',
    field: 'purchaseDate',
    width: 110,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_scmName') || '执行工厂',
    field: 'scmName',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('table_label_orderImport_settlementFactoryName') || '结算工厂',
    field: 'settlementFactoryName',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_orderScmName') || '名义工厂',
    field: 'orderScmName',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_temphxSkuNo') || '京东SKU编码',
    field: 'temphxSkuNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_channelEanNo') || '69编码',
    field: 'channelEanNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_ncNo') || 'NC',
    field: 'ncNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_tempGoodsName') || 'SKU名称',
    field: 'tempGoodsName',
    width: 280,
    align: 'left',
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_purchasePrice') || '采购单价',
    field: 'purchasePrice',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_purchaseQty') || '下单数量',
    field: 'purchaseQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_orderImport_ctnQty') || '采购箱数',
    field: 'ctnQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_tailCtnQty') || '采购尾箱',
    field: 'tailCtnQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_totalCtnQty') || '采购总箱数',
    field: 'totalCtnQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_subAmount') || '金额小计',
    field: 'subAmount',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_operateName') || '对接跟单',
    field: 'operateName',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_earliestDeliveryDate') || '预计交付日期',
    field: 'earliestDeliveryDate',
    width: 110,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_remark') || '备注',
    field: 'remark',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
]
